var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gauge"},[_c('div',{staticClass:"gauge-pointer",class:_vm.loading?'animated':'',style:(_vm.rotationStyle)}),_c('div',{staticClass:"limit bottom"},[_vm._v("0%")]),_c('div',{staticClass:"limit top"},[_vm._v("100%")])])}
var staticRenderFns = []

export { render, staticRenderFns }